import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";
import { Loader2, RotateCw } from "lucide-react";
import { toast } from "sonner";

export default function Webhooks() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState({ status: "", event_type: "" });
  const [busy, setBusy] = useState(false);
  const [sel, setSel] = useState(null);

  const load = async () => {
    setBusy(true);
    const params = new URLSearchParams();
    Object.entries(filter).forEach(([k, v]) => v && params.set(k, v));
    params.set("limit", "300");
    const { data } = await api.get(`/api/admin/webhooks?${params.toString()}`);
    setItems(data); setBusy(false);
  };
  useEffect(() => { load(); }, [filter]);

  const replay = async (w) => {
    await api.post(`/api/admin/webhooks/${w.id}/replay`);
    toast.success("Webhook replayed");
    load();
  };

  return (
    <div className="space-y-6" data-testid="webhooks-page">
      <div className="text-[var(--text-2)] text-sm">Operator webhook delivery logs. Failed/dead-letter entries can be replayed.</div>

      <div className="flex gap-3">
        <select value={filter.event_type} onChange={(e) => setFilter({ ...filter, event_type: e.target.value })}
                className="px-3 py-2 bg-[var(--surface)] border border-[var(--border)] rounded text-sm" data-testid="webhook-event-filter">
          <option value="">All events</option>
          {["BET", "WIN", "ROLLBACK", "REFUND", "BALANCE_CHANGE"].map(e => <option key={e} value={e}>{e}</option>)}
        </select>
        <select value={filter.status} onChange={(e) => setFilter({ ...filter, status: e.target.value })}
                className="px-3 py-2 bg-[var(--surface)] border border-[var(--border)] rounded text-sm" data-testid="webhook-status-filter">
          <option value="">All statuses</option>
          <option value="delivered">Delivered</option><option value="failed">Failed</option><option value="dead_letter">Dead letter</option><option value="pending">Pending</option>
        </select>
      </div>

      <div className="card-surface overflow-hidden">
        <div className="overflow-x-auto max-h-[70vh]">
          <table className="aggr-table">
            <thead><tr><th>Event</th><th>Operator</th><th>Status</th><th>Code</th><th>Latency</th><th>Attempts</th><th>When</th><th></th></tr></thead>
            <tbody>
              {busy && <tr><td colSpan={8} className="text-center py-6"><Loader2 className="inline animate-spin" size={14}/></td></tr>}
              {!busy && items.map(w => (
                <tr key={w.id} className="cursor-pointer" onClick={() => setSel(w)}>
                  <td><StatusBadge status={w.event_type}/></td>
                  <td className="font-mono text-xs">{w.operator_id}</td>
                  <td><StatusBadge status={w.status}/></td>
                  <td className="font-mono text-xs">{w.response_status}</td>
                  <td className="font-mono text-xs">{w.latency_ms}ms</td>
                  <td className="font-mono text-xs">{w.attempts}</td>
                  <td className="text-xs text-[var(--text-3)]">{new Date(w.created_at).toLocaleString()}</td>
                  <td onClick={(e) => e.stopPropagation()}>
                    {(w.status === "failed" || w.status === "dead_letter") && (
                      <button onClick={() => replay(w)} className="btn-ghost px-2 py-1 rounded text-xs flex items-center gap-1" data-testid={`replay-${w.id}`}>
                        <RotateCw size={11}/> Replay
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {sel && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setSel(null)}>
          <div className="card-surface w-full max-w-2xl p-6" onClick={(e) => e.stopPropagation()} data-testid="webhook-detail">
            <div className="text-lg font-semibold mb-3">Webhook · {sel.event_type}</div>
            <pre className="font-mono text-xs bg-[var(--bg)] border border-[var(--border)] rounded p-3 overflow-x-auto max-h-[60vh]">
{JSON.stringify(sel, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
}
